const ON_MY_DESIGN_EXPANDED_STORAGE_KEY = 'pmw_color_picker_on_my_design_expanded';

export const getPersistedIsOnMyDesignExpanded = (): boolean => {
  try {
    return localStorage.getItem(ON_MY_DESIGN_EXPANDED_STORAGE_KEY) === 'true';
  } catch {
    // localStorage may be unavailable
  }
  return false;
};

export const persistIsOnMyDesignExpanded = (isExpanded: boolean): void => {
  try {
    localStorage.setItem(ON_MY_DESIGN_EXPANDED_STORAGE_KEY, String(isExpanded));
  } catch {
    // localStorage may be unavailable
  }
};
